var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_vm._l((_vm.path.fullPath),function(waypoint,index){return [_c('gmap-marker',{key:("elzWaypont" + index),attrs:{"position":waypoint,"icon":_vm.marker,"draggable":false}})]})],2)}
var staticRenderFns = []

export { render, staticRenderFns }